import { render, staticRenderFns } from "./visibility-percentage-profile.vue?vue&type=template&id=2bdf9852&"
import script from "./visibility-percentage-profile.ts?vue&type=script&lang=ts&"
export * from "./visibility-percentage-profile.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports